// import Theme1 from "./Theme_1/App"
import Theme2 from "./Theme_2/App"
// import Theme3 from "./Theme_3/App"

export const ThemeSelect = ({id}) => {
    switch(id) {
        // case 1: 
        //     return <Theme1/>
        case 2: 
            return <Theme2/>
        // case 3: 
        //     return <Theme3/>

        default:
            return null
    }
}